import React from 'react';
import NewMealContent from './content';
import { MealProvider } from 'contexts/meal.context';

const NewMealLayout = () => {
  return (
    <MealProvider>
      <NewMealContent />
    </MealProvider>
  );
};

export default NewMealLayout;
